module.exports = __webpack_public_path__ + "static/media/download_btn.f6becdb0.png";